import { GeojsonApi } from '@datum-group/isogd-openapi/lib';
import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from 'mobx';

export class Record {
  @observable private _record?: GeoJSON.Feature = undefined;
  @observable private _tableName: string;
  @observable private _recordId: number | string;
  @observable private _isLoading = false;
  @observable private _error?: string = undefined;
  private _recordApi: GeojsonApi;

  constructor(
    tableName: string,
    recordId: number | string,
    recordApi: GeojsonApi,
  ) {
    this._recordApi = recordApi;
    this._tableName = tableName;
    this._recordId = recordId;
    makeObservable(this);
  }

  @computed get tableName() {
    return this._tableName;
  }

  @computed get recordId() {
    return this._recordId;
  }

  @computed get isLoading() {
    return this._isLoading;
  }

  @computed get error() {
    return this._error;
  }

  @computed get record(): GeoJSON.Feature | undefined {
    return this._record ? JSON.parse(JSON.stringify(this._record)) : undefined;
  }

  @computed get geometry(): GeoJSON.Geometry | undefined {
    return this._record
      ? JSON.parse(JSON.stringify(this._record.geometry))
      : undefined;
  }

  getProperty(key: string) {
    if (!this._record || !this._record.properties) return;

    return this._record.properties[key];
  }

  @action load = async () => {
    this._isLoading = true;
    this._error = undefined;

    try {
      const resp = await this._recordApi.apiGeojsonRead(
        '' + this._recordId,
        this._tableName,
      );

      // @ts-ignore
      runInAction(() => (this._record = resp.data));
    } catch (e) {
      runInAction(
        () =>
          (this._error = `Не удалось загрузить информацию о записи в таблице ${this._tableName} с id ${this._recordId}`),
      );
    } finally {
      runInAction(() => (this._isLoading = false));
    }
  };
}
